import { useState, Fragment, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import {
  createQueryString,
  sendApiRequest,
  uploadFile,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Alert,
  Input,
  InputGroup,
  Button,
  FormGroup,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Select,
  Spinner,
} from "design-react-kit";

const ExternalFlowUploadModal = ({
  modalOpen,
  modalCloseHandler,
  externalFlow,
}) => {
  const [file, setFile] = useState(null);
  const [typologyOptions, setTypologyOptions] = useState(null);
  const [selectedTypology, setSelectedTypology] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen) {
      setError(null);
      sendApiRequest(
        "Client/GetAllClientCodesWithExternalConfiguration",
        "GET",
        true,
        { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
        signIn,
        signOut,
        navigate,
        createQueryString,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
          } else {
            let clientCodes = [];
            response.data.map((item) =>
              clientCodes.push({
                value: item.code,
                label: item.name,
              })
            );
            setTypologyOptions(clientCodes);
            setSelectedTypology(externalFlow?.clientCode);
          }
          setIsLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  const closeModalHandler = () => {
    document.getElementById("file-form").reset();
    setFile(null);
    setSelectedTypology(null);
    modalCloseHandler();
  };

  const typologyChangeHandler = (selectedOption) =>
    setSelectedTypology(selectedOption);

  const uploadCompletedHandler = (response) => {
    if (response.errors !== null) {
      setError(response.errors);
    } else {
      closeModalHandler();
    }
    setIsLoading(false);
  };

  const uploadExternalFlowHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    uploadFile(
      file,
      {
        fiscalCode: userContext.selectedClientFiscalCode,
        clientCode: externalFlow?.clientCode ?? selectedTypology.value,
        externalFlowId: externalFlow?.id ?? 0,
      },
      "ExternalFlow/UploadZip",
      uploadCompletedHandler
    );
  };

  return (
    <Fragment>
      <Modal
        isOpen={modalOpen}
        labelledBy="externalflowUpload"
        toggle={closeModalHandler}
        align="center"
        keyboard={isLoading ? false : true}
      >
        <ModalHeader id="externalflowUpload" toggle={closeModalHandler}>
          <h6 className="text-capitalize text-center">
            {externalFlow === null || externalFlow === undefined
              ? "Carica flusso notifiche"
              : "Ricarica (sostituisci) flusso notifiche"}
          </h6>
        </ModalHeader>
        <ModalBody>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mb-5">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0 mt-2 mb-3 position-relative">
              {externalFlow !== null && externalFlow !== undefined && (
                <div>
                  <div className="col-12">
                    <h5 className="text-capitalize">
                      File (ZIP) da sostituire:{" "}
                      <span style={{ color: "#0073e6" }}>
                        {externalFlow?.zipFileName}
                      </span>
                    </h5>
                  </div>
                  <div className="col-12">
                    <h5 className="text-capitalize">
                      Tipologia Servizio:{" "}
                      <span style={{ color: "#0073e6 " }}>
                        {externalFlow?.clientCode}
                      </span>
                    </h5>
                  </div>
                </div>
              )}
              {(externalFlow === null || externalFlow === undefined) && (
                <div className="bootstrap-select-wrapper col-12">
                  <label htmlFor="clients">Tipologia Servizio: </label>
                  <Select
                    id="clients"
                    onChange={typologyChangeHandler}
                    options={typologyOptions}
                    value={selectedTypology}
                    placeholder="-Seleziona tipologia di servizio-"
                    aria-label="Seleziona"
                  />
                </div>
              )}
            </FormGroup>
          </div>
          <div className="form-row">
            <InputGroup className="col-sm-12 m-0 mb-4 align-items-center">
              <form id="file-form" className="col-sm-12 m-0">
                <label
                  htmlFor="file"
                  role="button"
                  className="btn-secondary rounded p-2 mr-2"
                >
                  Scegli file da caricare
                </label>
                <Input
                  className="btn"
                  id="file"
                  type="file"
                  style={{ display: "none" }}
                  accept=".zip"
                  onClick={() => document.getElementById("file-form").reset()}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setError(null);
                    if (file !== undefined && file !== null) {
                      if (
                        file.type === "application/zip" ||
                        file.type === "application/x-zip" ||
                        file.type === "application/x-zip-compressed" ||
                        file.name.endsWith(".zip")
                      ) {
                        setFile(file);
                      } else {
                        setFile(null);
                        setError([<p>Il file scelto non è uno "zip"!</p>]);
                      }
                    }
                  }}
                />
                <span>
                  {file === null ? "Nessun file scelto" : `${file?.name}`}
                </span>
              </form>
            </InputGroup>
          </div>
          <FormGroup className="col-sm-12 mb-3 d-flex align-items-center justify-content-end">
            <Button
              id="user-cancel"
              color="white"
              className="mr-2"
              onClick={closeModalHandler}
            >
              Annulla
            </Button>
            <Button
              disabled={
                file === null ||
                selectedTypology === null ||
                selectedTypology === undefined
              }
              style={{
                backgroundColor: "#5EB423",
                color: "#fff",
                padding: "7px 15px",
              }}
              id="external-flow-upload"
              type="submit"
              onClick={(e) => uploadExternalFlowHandler(e)}
            >
              <Icon icon="it-check" fill="#ffffff" /> Carica file
            </Button>
          </FormGroup>
        </ModalBody>
      </Modal>
      {isLoading && (
        <div className="modal_backdrop">
          <div className="position-relative upload-spinner">
            <p style={{ height: "50px", marginBottom: "7rem" }}>
              <Spinner double active />
            </p>
            <h3 style={{ color: "#fff" }}>
              Attendere prego, caricamento in corso...
            </h3>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ExternalFlowUploadModal;
